// src/assets/js/confettiControl.js
import ConfettiGenerator from 'confetti-js'

export function launchConfetti() {
	const canvas = document.getElementById('bw-canvas')
	if (!canvas) {
		console.error('Confetti canvas not found')
		return
	}

	canvas.style.opacity = '1'

	const confettiSettings = { target: 'bw-canvas' }
	const confetti = new ConfettiGenerator(confettiSettings)
	confetti.render()

	// Begin fade out after 4 seconds, allowing 1 second for fadeout effect
	setTimeout(() => {
		canvas.style.opacity = '0'

		setTimeout(() => {
			confetti.clear()

			canvas.style.opacity = '1'
		}, 1000)
	}, 4000)
}
